import { Container as MuiContainer } from "@mui/material";
import React, { PropsWithChildren } from "react";
import * as ReactRedux from "react-redux";
import { Header, LeftNavMenu, Main } from ".";
import { isLoggedIn } from "../components/cookies";
import { ErrorDialog } from "../components/errorDialog";
import { RootState } from "../store";

const BaseContainer: React.FC<RootState> = (
    props: PropsWithChildren<RootState>
) => {
    if (!isLoggedIn()) {
        return (
            <MuiContainer maxWidth={false} disableGutters={true}>
                {props.children}
            </MuiContainer>
        );
    }

    return (
        <MuiContainer
            maxWidth={false}
            disableGutters={true}
            sx={{ display: "flex" }}
        >
            <Header {...props.common} />
            <LeftNavMenu {...props.common} />
            <Main open={props.common.navigation.leftNavMenuIsCollapsed}>
                {props.children}
            </Main>
            <ErrorDialog errorMessage={props.common.errorMessage} />
        </MuiContainer>
    );
};

export const Container = ReactRedux.connect((state: RootState) => state)(
    BaseContainer
);
